/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-09-09 18:47:28 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-26 01:52:47
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class CommentService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/comments`;

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  createComment(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  getComments(page: number, limit: number, celeb: string) {
    return this.http.get(`${this.url}?page=${page}&limit=${limit}&celeb=${celeb}&lang=${this.transService.lang}`);
  }

  updateComment(id: string, data) {
    return this.http.put(`${this.url}/${id}?lang=${this.transService.lang}`, data);
  }

  deleteComment(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  replyComment(id: string, content: string) {
    return this.http.put(`${this.url}/${id}/reply?lang=${this.transService.lang}`, {
      content
    });
  }

  replyUpdateComment(id: string, replyId: string, content: string) {
    return this.http.put(`${this.url}/${id}/reply-update?lang=${this.transService.lang}`, {
      replyId,
      content
    });
  }

  replyDeleteComment(id: string, replyId: string) {
    return this.http.put(`${this.url}/${id}/reply-delete?lang=${this.transService.lang}`, {
      replyId,
    });
  }

  likeComment(id: string, replyId: string, like: boolean) {
    return this.http.put(`${this.url}/${id}/like?lang=${this.transService.lang}`, {
      replyId,
      like
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/comment.service.ts